(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('xoa-sticky-product')) {
    customElements.define(
      'xoa-sticky-product',
      class XoaStickyProduct extends HTMLElement {
        connectedCallback() {
          this.stickyButton = this.querySelector('[data-xoa-sticky-submit]');
          this.price = this.querySelector('[data-xoa-sticky-price]');
          this.variant = this.querySelector('[data-xoa-sticky-variant]');
          this.quantity = this.querySelector('[data-xoa-sticky-quantity]');
          this.media = this.querySelector('[data-xoa-sticky-media]');
          this.image = this.querySelector('.xoa-sticky-product__image');
          this.spinner = this.querySelector('.loading__spinner');
          this.handleDocumentInput = this.handleDocumentInput.bind(this);
          this.handleViewportChange = this.handleViewportChange.bind(this);
          this.handleSubmit = this.handleSubmit.bind(this);
          this.refreshPrimaryElements();
          if (!this.primaryButton || !this.stickyButton) return;
          this.syncButtonState();
          this.stickyButton.addEventListener('click', this.handleSubmit);
          document.addEventListener('input', this.handleDocumentInput);
          document.addEventListener('change', this.handleDocumentInput);
          window.addEventListener('resize', this.handleViewportChange, { passive: true });
          window.addEventListener('scroll', this.handleViewportChange, { passive: true });
          this.buttonObserver = new MutationObserver(() => {
            this.syncButtonState();
          });
          this.buttonObserver.observe(this.primaryButton, { attributes: true, childList: true, subtree: true });
          this.visibilityObserver = new IntersectionObserver((entries) => {
            const entry = entries[0];
            const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', shouldShow);
            this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          });
          this.visibilityObserver.observe(this.primaryButton);
          this.updateDetails();
          this.handleViewportChange();
        }

        refreshPrimaryElements() {
          this.primaryButton = document.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
          this.quantityInput = document.querySelector(`#Quantity-${this.dataset.section}`);
          this.variantInput = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
        }

        handleSubmit() {
          this.refreshPrimaryElements();
          if (this.primaryButton?.disabled) return;
          this.primaryButton?.click();
        }

        handleDocumentInput(event) {
          if (event.target === this.quantityInput) {
            this.quantity.textContent = event.target.value;
            return;
          }
          if (event.target === this.variantInput || event.target.closest?.(`#ProductInfo-${this.dataset.section}`)) {
            window.clearTimeout(this.updateTimer);
            this.updateTimer = window.setTimeout(() => this.updateDetails(), 90);
          }
        }

        updateDetails() {
          this.refreshPrimaryElements();
          if (this.quantityInput) this.quantity.textContent = this.quantityInput.value;
          const selectedVariantNode = document.querySelector(
            `#variant-selects-${this.dataset.section} [data-selected-variant]`
          );
          let selectedVariant;
          try {
            selectedVariant = selectedVariantNode ? JSON.parse(selectedVariantNode.textContent) : null;
          } catch (error) {
            selectedVariant = null;
          }
          if (this.variant) {
            const variantTitle = selectedVariant?.title || '';
            const variantValue = this.variant.querySelector('b');
            if (variantValue) variantValue.textContent = variantTitle;
            this.variant.hidden = this.dataset.hasOnlyDefaultVariant === 'true' || variantTitle === 'Default Title';
          }
          const priceRoot = document.querySelector(`#price-${this.dataset.section} .price`);
          if (priceRoot && this.price) {
            const priceSelector = priceRoot.classList.contains('price--on-sale')
              ? '.price-item--sale'
              : '.price__regular .price-item--regular';
            const activePrice = priceRoot.querySelector(priceSelector) || priceRoot.querySelector('.price-item');
            if (activePrice) this.price.textContent = activePrice.textContent.trim();
          }
          const variantImage = selectedVariant?.featured_media?.preview_image?.src;
          if (variantImage) this.updateImage(variantImage);
          this.syncButtonState();
        }

        updateImage(source) {
          if (!this.image) {
            this.image = document.createElement('img');
            this.image.className = 'xoa-sticky-product__image';
            this.image.alt = '';
            this.image.setAttribute('data-xoa-sticky-image', '');
            this.media.replaceChildren(this.image);
          }
          const imageUrl = new URL(source, window.location.origin);
          imageUrl.searchParams.set('width', '160');
          this.image.src = imageUrl.toString();
          this.image.removeAttribute('srcset');
        }

        syncButtonState() {
          if (!this.primaryButton || !this.stickyButton) return;
          const isLoading = this.primaryButton.classList.contains('loading');
          this.stickyButton.disabled = this.primaryButton.disabled;
          this.stickyButton.classList.toggle('is-loading', isLoading);
          this.spinner?.classList.toggle('hidden', !isLoading);
        }

        handleViewportChange() {
          if (this.viewportFrame) return;
          this.viewportFrame = window.requestAnimationFrame(() => {
            const header = document.querySelector('.section-header');
            const headerRect = header?.getBoundingClientRect();
            const headerBottom = headerRect && headerRect.bottom > 0 && headerRect.top <= 1 ? headerRect.bottom : 0;
            this.style.setProperty('--xoa-sticky-top', `${Math.max(12, headerBottom + 10)}px`);
            this.viewportFrame = null;
          });
        }

        disconnectedCallback() {
          this.stickyButton?.removeEventListener('click', this.handleSubmit);
          document.removeEventListener('input', this.handleDocumentInput);
          document.removeEventListener('change', this.handleDocumentInput);
          window.removeEventListener('resize', this.handleViewportChange);
          window.removeEventListener('scroll', this.handleViewportChange);
          this.buttonObserver?.disconnect();
          this.visibilityObserver?.disconnect();
          window.clearTimeout(this.updateTimer);
          if (this.viewportFrame) window.cancelAnimationFrame(this.viewportFrame);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xoa-campaign-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xoa-campaign-hero')) {
    customElements.define(
      'xoa-campaign-hero',
      class XoaCampaignHero extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-xoa-slide]'));
          this.current = 0;
          this.status = this.querySelector('[data-xoa-current]');
          this.previousButton = this.querySelector('[data-xoa-previous]');
          this.nextButton = this.querySelector('[data-xoa-next]');
          this.previousButton?.addEventListener('click', () => this.show(this.current - 1));
          this.nextButton?.addEventListener('click', () => this.show(this.current + 1));
          this.addEventListener('shopify:block:select', (event) => {
            const selected = this.slides.indexOf(event.target);
            if (selected >= 0) this.show(selected);
          });
        }

        show(index) {
          if (this.slides.length < 2) return;
          this.current = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            slide.hidden = slideIndex !== this.current;
            slide.setAttribute('aria-hidden', slideIndex === this.current ? 'false' : 'true');
          });
          if (this.status) this.status.textContent = String(this.current + 1);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xoa-work-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xoa-work-carousel')) {
    customElements.define(
      'xoa-work-carousel',
      class XoaWorkCarousel extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-work-slide]'));
          this.dialogs = Array.from(this.querySelectorAll('[data-work-dialog]'));
          this.dots = Array.from(this.querySelectorAll('[data-work-dot]'));
          this.track = this.querySelector('[data-work-track]');
          this.viewport = this.querySelector('[data-work-viewport]');
          this.previousButton = this.querySelector('[data-work-previous]');
          this.nextButton = this.querySelector('[data-work-next]');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
          this.interval = Number(this.dataset.interval) || 5000;
          this.current = 0;
          this.isVisible = true;
          this.pointerStart = null;
          this.resizeFrame = null;

          this.previousButton?.addEventListener('click', () => this.show(this.current - 1, true));
          this.nextButton?.addEventListener('click', () => this.show(this.current + 1, true));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.index), true)));
          this.slides.forEach((slide, index) => {
            slide.querySelector('[data-work-open]')?.addEventListener('click', () => {
              this.show(index, false);
              this.openDialog(index);
            });
          });

          this.dialogs.forEach((dialog, index) => {
            dialog.addEventListener('click', (event) => {
              if (event.target === dialog) dialog.close();
            });
            dialog.querySelector('[data-dialog-previous]')?.addEventListener('click', () => this.switchDialog(index - 1));
            dialog.querySelector('[data-dialog-next]')?.addEventListener('click', () => this.switchDialog(index + 1));
            dialog.addEventListener('close', () => this.updateAutoplay());
          });

          this.viewport?.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.show(this.current - 1, true);
            }
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.show(this.current + 1, true);
            }
          });
          this.viewport?.addEventListener('pointerdown', (event) => {
            this.pointerStart = event.clientX;
          }, { passive: true });
          this.viewport?.addEventListener('pointerup', (event) => this.handleSwipe(event.clientX), { passive: true });
          this.viewport?.addEventListener('pointercancel', () => {
            this.pointerStart = null;
          });

          this.addEventListener('mouseenter', () => this.pauseTemporarily());
          this.addEventListener('mouseleave', () => this.resumeTemporarily());
          this.addEventListener('focusin', () => this.pauseTemporarily());
          this.addEventListener('focusout', () => {
            window.setTimeout(() => {
              if (!this.contains(document.activeElement)) this.resumeTemporarily();
            }, 0);
          });
          this.addEventListener('shopify:block:select', (event) => {
            const selected = this.slides.indexOf(event.target.closest('[data-work-slide]'));
            if (selected >= 0) this.show(selected, false);
          });

          this.resizeObserver = new ResizeObserver(() => {
            window.cancelAnimationFrame(this.resizeFrame);
            this.resizeFrame = window.requestAnimationFrame(() => this.positionTrack(false));
          });
          if (this.viewport) this.resizeObserver.observe(this.viewport);

          this.intersectionObserver = new IntersectionObserver((entries) => {
            this.isVisible = entries[0]?.isIntersecting ?? true;
            this.updateAutoplay();
          }, { threshold: 0.45 });
          this.intersectionObserver.observe(this);
          this.visibilityHandler = () => this.updateAutoplay();
          document.addEventListener('visibilitychange', this.visibilityHandler);

          this.show(0, false);
          this.updateAutoplay();
        }

        disconnectedCallback() {
          window.clearTimeout(this.timer);
          window.cancelAnimationFrame(this.resizeFrame);
          this.resizeObserver?.disconnect();
          this.intersectionObserver?.disconnect();
          document.removeEventListener('visibilitychange', this.visibilityHandler);
        }

        normalize(index) {
          return (index + this.slides.length) % this.slides.length;
        }

        show(index, userInitiated) {
          if (!this.slides.length) return;
          const nextIndex = this.normalize(index);
          const update = () => this.applySlide(nextIndex, userInitiated);
          if (userInitiated && document.startViewTransition && !this.reducedMotion) {
            const transition = document.startViewTransition(update);
            transition.finished.catch(() => {});
          } else {
            update();
          }
        }

        applySlide(index, userInitiated) {
          this.current = index;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === index;
            slide.setAttribute('aria-current', active ? 'true' : 'false');
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            const trigger = slide.querySelector('[data-work-open]');
            if (trigger) trigger.tabIndex = active ? 0 : -1;
          });
          this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
          this.positionTrack(true);
          if (userInitiated) this.restartAutoplay();
        }

        positionTrack(animate) {
          const slide = this.slides[this.current];
          if (!slide || !this.track || !this.viewport) return;
          if (!animate) {
            this.track.style.transition = 'none';
            window.requestAnimationFrame(() => {
              this.track.style.transition = '';
            });
          }
          const viewportCenter = this.viewport.clientWidth / 2;
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          this.track.style.transform = `translate3d(${viewportCenter - slideCenter}px, 0, 0)`;
        }

        handleSwipe(pointerEnd) {
          if (this.pointerStart === null) return;
          const distance = pointerEnd - this.pointerStart;
          this.pointerStart = null;
          if (Math.abs(distance) < 45) return;
          this.show(this.current + (distance < 0 ? 1 : -1), true);
        }

        openDialog(index) {
          const dialog = this.dialogs[this.normalize(index)];
          if (!dialog?.showModal) return;
          window.clearTimeout(this.timer);
          const open = () => dialog.showModal();
          if (document.startViewTransition && !this.reducedMotion) {
            const transition = document.startViewTransition(open);
            transition.finished.catch(() => {});
          } else {
            open();
          }
        }

        switchDialog(index) {
          const currentDialog = this.dialogs.find((dialog) => dialog.open);
          const nextIndex = this.normalize(index);
          currentDialog?.close();
          this.show(nextIndex, false);
          window.requestAnimationFrame(() => this.openDialog(nextIndex));
        }

        pauseTemporarily() {
          window.clearTimeout(this.timer);
        }

        resumeTemporarily() {
          this.updateAutoplay();
        }

        restartAutoplay() {
          window.clearTimeout(this.timer);
          this.updateAutoplay();
        }

        updateAutoplay() {
          window.clearTimeout(this.timer);
          const dialogOpen = this.dialogs.some((dialog) => dialog.open);
          const shouldPlay = this.autoplayEnabled && this.isVisible && !document.hidden && !dialogOpen && !this.matches(':hover') && !this.contains(document.activeElement);
          if (!shouldPlay || this.slides.length < 2) return;
          this.timer = window.setTimeout(() => {
            this.show(this.current + 1, false);
            this.updateAutoplay();
          }, this.interval);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
